import {useEffect} from "react";
import "./worksapce.css";
import {useDispatch, useSelector} from "react-redux";
import {BoardsAPI} from "../../store/api/get/Board/Board";
import {SET_ACTIVE_BOARD} from "../../store/constants";
import {BoardsUIX} from "./BoardsUIX";

export const WorkSpace = ({user}) => {

    const showForm = useSelector(state => state.boardCreate.showForm);
    const title = useSelector(state => state.boardCreate.title);
    const selectedImage = useSelector(state => state.boardCreate.selectedImage);

    const dispatch = useDispatch();
    const boards = useSelector(state => state.boards.boards);
    useEffect(() => {
        dispatch(BoardsAPI(user.id));
    }, [dispatch]);


    const setActiveBoard = (board) => {
        dispatch({type: SET_ACTIVE_BOARD, payload: board});
    };
    const archivedBoards = boards.filter((el) => el.is_archive);

    return (
        <div className="main__workspace">
            <h2 className="workspace__title">Active Boards</h2>
            <BoardsUIX boards={boards.filter((el) => !el.is_archive)} setActiveBoard={setActiveBoard}
                       is_create={true}/>
            <h2 className="workspace__title">Archive Boards</h2>
            {
                boards.length !== 0 && (
                    <BoardsUIX boards={archivedBoards} setActiveBoard={setActiveBoard} showForm={showForm}
                               selectedImage={selectedImage}
                               title={title} is_create={false}/>
                )
            }

        </div>
    );
};